import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "mb-0 fw-bold" }
const _hoisted_4 = { class: "text-muted small mb-20" }
const _hoisted_5 = {
  id: "consent-box",
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing flex-grow-1 overflow-y-auto"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "form-check form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_8 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "accept"
}
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.version?.title ?? ''), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.version?.revision_number ?? ''), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_5, [
          _createCommentVNode(" <div class=\"d-flex justify-content-center h-100 align-items-center\" v-if=\"consent_details === undefined\">\n                    <SpinnerLoading class=\"h-auto\"/>\n                </div> "),
          _createElementVNode("div", {
            class: "card-body p-15 p-sm-20 p-md-25",
            innerHTML: _ctx.version?.body
          }, null, 8 /* PROPS */, _hoisted_6)
        ]),
        (_ctx.version?.has_checkbox ?? false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input shadow-none",
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accept) = $event)),
                id: "accept"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, _ctx.accept]
              ]),
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.version?.checkbox_disclaimer ?? ''), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            disabled: !_ctx.nextEnabled,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitConsent && _ctx.submitConsent(...args))),
            class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
          }, _toDisplayString(_ctx.$t('cta.next')), 9 /* TEXT, PROPS */, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_AlertModal, {
      id: "cosnent_update",
      title: _ctx.$t('feature.$consents.update'),
      message: _ctx.$t('feature.$consents.update_message'),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.alertModal?.hide()))
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}